import { AxiosPromise } from "axios";
import { format } from "date-fns";
import { httpClient } from "src/shared/services/httpClient";
import {
  TActiveDirectPurchasesJSONResponseData,
  TNamePurchaseClaimsForChamberResponseData,
  TNamePurchaseClaimsJSONResponseData,
  TNamePurchasePastClaimParamsResponseData,
  TNamePurchasePastClaimsJSONResponseData,
} from "../features/types";

export const nameTitleAcknoledge = ({
  companyNameTitle,
  companyNameTitleLatin,
  mode,
}: {
  companyNameTitle: string;
  companyNameTitleLatin: string;
  mode: string;
}) => {
  const formData = new FormData();
  formData.append("companyNameTitle", companyNameTitle);
  formData.append("companyNameTitleLatin", companyNameTitleLatin);
  formData.append("mode", mode);
  return httpClient.post("namePurchase/namePurchaseAcknowledgeReact", formData);
};

export const getNameTitlePurchaseFormParams = ({ mode }: { mode: string }) => {
  if (mode == "pre") {
    return httpClient.get("namePurchase/nameTitlePurchaseForm");
  }

  return httpClient.get("namePurchase/directPurchaseFormReact");
};

export const getActivePurchases = (formData: FormData) => {
  return httpClient.post(
    "namePurchase/getActivePurchaseApplicationsJSON",
    formData,
  );
};

export const getGgpsLogin = ({ mode }: { mode: string }) => {
  return httpClient.get(`welcome/ggpsLogin?mode=${mode}`);
};

export const getOauthHandleForNamePurchase = (
  mode: string,
  token: string,
  oauth_verifier: string,
) => {
  if (mode == "companyNameApprover") {
    return httpClient.get(
      `welcome/oauthHandleForCompanyPersonReact?mode=${mode}&oauth_token=${token}&oauth_verifier=${oauth_verifier}`,
    );
  }

  return httpClient.get(
    `welcome/oauthHandleForNamePurchaseReact?mode=${mode}&oauth_token=${token}&oauth_verifier=${oauth_verifier}`,
  );
};

export const getCorporateStatus = () => {
  return httpClient.get("namePurchase/directPurchaseUserForm");
};

export const submitClaim = ({
  claimText,
  chamberResponsible,
  prefecture,
  companyNameTitle,
  mode,
  nameTitlePurchaseAppId,
}: {
  claimText: string;
  chamberResponsible: number;
  prefecture: number;
  companyNameTitle: string;
  mode: string;
  nameTitlePurchaseAppId: string;
}) => {
  const formData = new FormData();
  formData.append("claimText", claimText);
  formData.append(
    "chamberResponsible",
    chamberResponsible ? chamberResponsible.toString() : "",
  );
  formData.append("prefecture", prefecture ? prefecture.toString() : "");
  formData.append("companyNameTitle", companyNameTitle);
  if (mode == "pre") {
    if (nameTitlePurchaseAppId) {
      formData.append("nameTitlePurchaseAppId", nameTitlePurchaseAppId);
    }
    return httpClient.post("namePurchase/submitClaim", formData);
  }
  return httpClient.post("namePurchase/directPurchaseClaimSubmit", formData);
};

export const namePurchaseSubmit = ({
  mode,
  companyNameTitle,
  isProhibitedDirty,
  nameTitlePurchaseAppId,
  purchaseMode,
}: {
  mode: string;
  companyNameTitle: string;
  isProhibitedDirty: boolean;
  nameTitlePurchaseAppId?: string;
  purchaseMode: string;
}) => {
  const formData = new FormData();
  formData.append("mode", mode);
  formData.append("companyNameTitle", companyNameTitle);
  formData.append("isProhibitedDirty", isProhibitedDirty.toString());
  formData.append("nameTitlePurchaseAppId", nameTitlePurchaseAppId ?? "");

  if (purchaseMode == "direct") {
    return httpClient.post("namePurchase/directPurchaseSubmit", formData);
  }
  return httpClient.post("namePurchase/namePurchaseSubmit", formData);
};

export const directPurchaseUserSubmit = (filters: {
  corporateStatus: string;
  afm: string;
  email: string;
  phone: string;
}) => {
  return httpClient.post(
    "/namePurchase/directPurchaseUserSubmitReact",
    filters,
  );
};

export const directPurchaseClaimSubmit = () => {};

export const getNamePurchaseSubmitSuccess = (appId: string) =>
  httpClient.get(
    "/namePurchase/namePurchaseSubmitSuccess?applicationId=" + appId,
  );
export const getNamePurchaseDetails = (nameTitlePurchaseAppId: string) => {
  const formData = new FormData();
  formData.append("nameTitlePurchaseAppId", nameTitlePurchaseAppId);
  return httpClient.post("namePurchase/namePurchaseDetails", formData);
};

export const postNamePurchaseClaimsForChamberJSON = (filters: {
  fromDate: Date | undefined;
  toDate: Date | undefined;
  namePurchaseAppId: number | undefined;
  chamberUser: number[] | number | undefined;
  pageIndex: number;
  pageSize: number;
}): AxiosPromise<TNamePurchaseClaimsJSONResponseData> => {
  const formData = new FormData();
  formData.append(
    "fromDate",
    filters.fromDate ? format(filters.fromDate, "dd/MM/yyyy") : "",
  );
  formData.append(
    "toDate",
    filters.toDate ? format(filters.toDate, "dd/MM/yyyy") : "",
  );
  formData.append(
    "namePurchaseAppId",
    filters.namePurchaseAppId ? filters.namePurchaseAppId.toString() : "",
  );
  formData.append("length", filters.pageSize.toString());
  formData.append("start", (filters.pageIndex * filters.pageSize).toString());
  if (Array.isArray(filters.chamberUser)) {
    filters.chamberUser.forEach((chamberUser) => {
      formData.append("chamberUser[]", chamberUser.toString());
    });
  } else if (typeof filters.chamberUser === "number") {
    formData.append("chamberUser[]", filters.chamberUser.toString());
  }
  return httpClient.post(
    `namePurchase/namePurchaseClaimApplicationsJSON`,
    formData,
  );
};

export const getNamePurchaseClaimsForChamberParams =
  (): AxiosPromise<TNamePurchaseClaimsForChamberResponseData> =>
    httpClient.get("namePurchase/namePurchaseClaimsForChamber");

export const getNamePurchasePastClaimsForChamberParams =
  (): AxiosPromise<TNamePurchasePastClaimParamsResponseData> =>
    httpClient.get("namePurchase/namePurchasePastClaimsForChamber");
export const postNamePurchasePastClaimsJSON = (filters: {
  fromDate: Date | undefined;
  toDate: Date | undefined;
  namePurchaseAppId: number | undefined;
  code: string | undefined;
  pageIndex: number;
  pageSize: number;
}): AxiosPromise<TNamePurchasePastClaimsJSONResponseData> => {
  const formData = new FormData();
  formData.append(
    "fromDate",
    filters.fromDate ? format(filters.fromDate, "dd/MM/yyyy") : "",
  );
  formData.append(
    "toDate",
    filters.toDate ? format(filters.toDate, "dd/MM/yyyy") : "",
  );
  formData.append(
    "namePurchaseAppId",
    filters.namePurchaseAppId ? filters.namePurchaseAppId.toString() : "",
  );
  formData.append("code", filters.code ? filters.code : "");
  formData.append("length", filters.pageSize.toString());
  formData.append("start", (filters.pageIndex * filters.pageSize).toString());
  return httpClient.post(
    `namePurchase/namePurchasePastApplicationsJSON`,
    formData,
  );
};

export const cancelNamePurchaseApplication = ({
  applicationId,
}: {
  applicationId: number;
}) => {
  const formData = new FormData();
  formData.append("nameTitlePurchaseAppId", applicationId.toString());
  return httpClient.post("namePurchase/cancelNamePurchaseApp", formData);
};

export const assignNamePurchaseApplication = ({
  applicationId,
  userId,
  message,
}: {
  applicationId: number;
  userId: number;
  message: string;
}) => {
  const formData = new FormData();
  formData.append("nameTitlePurchaseAppId", applicationId.toString());
  formData.append("toUser", userId.toString());
  formData.append("mode", "FROM_CHAMBER_TO_CHAMBER");
  formData.append("message", message ?? "");
  return httpClient.post("namePurchase/forwardApplication", formData);
};

export const getAssignNamePurchaseApplicationParams = ({
  applicationId,
}: {
  applicationId: number;
}) => {
  return httpClient.get(
    `namePurchase/forwardToChamberUserForm${
      applicationId ? `?nameTitlePurchaseAppId=${applicationId}` : ""
    }`,
  );
};

export const assignedUserAcceptNamePurchaseApplication = ({
  applicationId,
  message,
}: {
  applicationId: number;
  message: string;
}) => {
  const formData = new FormData();
  formData.append("nameTitlePurchaseAppId", applicationId.toString());
  formData.append("mode", "FROM_CHAMBER_TO_COMPANY");
  formData.append("message", message ?? "");
  return httpClient.post("namePurchase/assignedChamberApprovesClaim", formData);
};

export const assignedUserDisapprovesNamePurchaseApplication = ({
  applicationId,
  message,
}: {
  applicationId: number;
  message: string;
}) => {
  const formData = new FormData();
  formData.append("nameTitlePurchaseAppId", applicationId.toString());
  formData.append("mode", "FROM_CHAMBER_TO_COMPANY");
  formData.append("message", message);
  return httpClient.post(
    "namePurchase/assignedChamberDisapprovesClaim",
    formData,
  );
};

export const timeRenewal = ({ applicationId }: { applicationId: number }) => {
  const formData = new FormData();
  formData.append("appId", applicationId.toString());
  return httpClient.post("namePurchase/timeRenewalNamePurchaseApp", formData);
};

export const getCompanyNames = (formData: FormData) => {
  return httpClient.post("namePurchase/getCompanyNamesJSON", formData);
};

export const getCompanyNamesDetails = (nameTitlePurchaseAppId: string) => {
  const formData = new FormData();
  formData.append("nameTitlePurchaseAppId", nameTitlePurchaseAppId);
  return httpClient.post("namePurchase/companyNamesDetails", formData);
};
export const getPendingDirectPurchases = () => {
  return httpClient.get("namePurchase/pendingDirectPurchases");
};

export const getActiveDirectPurchasesJSON = (searchFilters: {
  fromDate: Date | undefined;
  toDate: Date | undefined;
  b02_id: number | undefined;
  pageIndex: number;
  pageSize: number;
  // columnsCount: number;
}): AxiosPromise<TActiveDirectPurchasesJSONResponseData> => {
  const formData = new FormData();
  formData.append(
    "fromDate",
    searchFilters.fromDate ? format(searchFilters.fromDate, "dd/MM/yyyy") : "",
  );
  formData.append(
    "toDate",
    searchFilters.toDate ? format(searchFilters.toDate, "dd/MM/yyyy") : "",
  );
  formData.append(
    "b02_id",
    searchFilters.b02_id ? searchFilters.b02_id.toString() : "",
  );
  formData.append("length", searchFilters.pageSize.toString());
  formData.append(
    "start",
    (searchFilters.pageIndex * searchFilters.pageSize).toString(),
  );
  formData.append("pendingOnly", "1");

  formData.append("appType", "2,3,4");
  return httpClient.post(
    `namePurchase/getActivePurchaseApplicationsJSON`,
    formData,
  );
};

export const getDirectPurchaseConflict = () =>
  httpClient.get("namePurchase/directPurchaseConflictFormReact");

export const submitDirectPurchaseConflict = (data: {}) =>
  httpClient.post("namePurchase/directPurchaseApprovalSubmitReact", data);

export const getApproverRequest = () =>
  httpClient.get("namePurchase/getApproverList");

export const submitRequest = ({
  id,
  type,
}: {
  id: number;
  type: "approve" | "decline";
}) => {
  if (type == "approve") {
    return httpClient.post("namePurchase/approveRequest", {
      companyNameRequest: id,
    });
  }
  return httpClient.post("namePurchase/rejectRequest", {
    companyNameRequest: id,
  });
};

export const checkCodeNameValid = ({ codeName }: { codeName: string }) =>
  httpClient.get(`namePurchase/checkCodeName?code=${codeName}`);

export const submitUsePurchaseForm = ({ data }: { data: Object }) =>
  httpClient.post("namePurchase/submitUsePurchaseForm", data);

export const cancelNamePurchase = () =>
  httpClient.post("namePurchase/cancelNamePurchaseApplication");
